export default {
  uploading: '上传中...',
  loading: '加载中...',
  refreshRetry: '刷新重试',
  // 公共部分
  common: {
    home: '首页',
    assistant: '助教',
    signIn: '签到',
    mine: '我的',
    search: '搜索',
    searchCourse: '搜索课程',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    loading: '加载中...',
    noData: '暂无数据',
    success: '成功',
    failed: '失败',
    error: '错误',
    warning: '警告',
    tip: '提示',
    close: '关闭',
    view: '查看',
    download: '下载',
    upload: '上传',
    reset: '重置',
    refresh: '刷新',
    complete: '完成',
    all: '全部',
    selectAll: '全选',
    more: '更多',
    pleaseEnter: '请输入',
    correctAnswer: '正确答案',
    gotIt: '我知道了'
  },
  unit: {
    agent: '{num}个智能体',
    kps: '{num}个',
    errorReview: '错题{num}个'
  },

  login: {
    // 欢迎标题
    welcomeTitle: '欢迎登录U课AI',
    loginIllustration: '登录插画',

    // 登录模式
    accountLogin: '学号登录',
    phoneLogin: '手机号登录',
    phoneNumberLogin: '手机号码登录',
    wechatLogin: '微信扫码登录',
    bindAccount: '绑定账号',
    rebindAccount: '绑定账号信息',
    bindAccountInfo: '绑定账号信息',
    rebindAccountInfo: '换绑账号信息',
    verifyCodeLogin: '验证码登录',

    // 表单标签
    selectSchool: '选择学校',
    studentId: '学号',
    password: '密码',
    phoneNumber: '手机号',
    phoneNumberLabel: '手机号码',
    verifyCode: '验证码',
    school: '学校',
    name: '姓名',

    // 占位符
    pleaseSelectSchool: '请选择学校',
    pleaseInputStudentId: '请输入学号',
    pleaseInputPassword: '请输入密码',
    pleaseInputPhone: '请输入手机号',
    pleaseInputPhoneNumber: '请输入您的手机号码',
    pleaseInputVerifyCode: '请输入验证码',
    pleaseInputName: '请输入姓名',

    // 提示信息
    bindStudentIdTip: '请绑定您的学号以完成登录',

    // 按钮
    loginBtn: '登录',
    getVerifyCode: '获取验证码',
    resend: '重新发送',
    contactService: '联系客服',
    contactCustomerService: '联系客服',
    backToWechatScan: '返回微信扫码',
    backToPhoneLogin: '返回手机号登录',
    confirmPassword: '确认密码',
    refreshQrCode: '刷新二维码',
    generatingQrCode: '正在生成二维码...',
    complete: '完成',
    gotIt: '我知道了',
    later: '稍后再说',
    updatePassword: '去修改',
    verifyPassword: '校验密码',
    loginWithStudentId: '用学号登录',

    // 复选框
    agreeProtocol: '我已阅读并同意',
    userAgreement: '《U课AI用户协议》',
    and: '和',
    privacyPolicy: '《隐私政策》',
    loginAgreement: '登录即代表您同意《U课AI用户协议》和《隐私政策》',
    scanLoginAgreement: '扫码登录即代表您同意《U课AI用户协议》和《隐私政策》',

    // 提示信息
    scanToLogin: '请使用微信扫一扫',
    accountBound: '该微信已绑定账号',
    boundPhone: '已绑定手机号',
    loginWithPhone: '登录后进入个人中心修改密码',
    defaultPasswordTip: '检测到您正在使用初始密码',
    changePasswordNow: '立即修改',
    changePasswordLater: '稍后修改',
    contactServiceTitle: '联系客服',
    workingHours: '工作时间',
    workingHoursValue: '周一至周五 9:00-18:00',
    servicePhone: '客服电话',
    serviceEmail: '客服邮箱',

    // 验证提示
    pleaseSelectSchoolTip: '请选择学校',
    pleaseInputStudentIdTip: '请填写学号',
    pleaseInputPasswordTip: '请填写密码',
    pleaseInputPhoneTip: '请填写手机号',
    pleaseInputCorrectPhone: '请填写正确的手机号',
    pleaseInputVerifyCodeTip: '请填写验证码',
    pleaseInputCorrectVerifyCode: '请输入正确的验证码',
    pleaseInputNameTip: '请填写姓名',
    pleaseAgreeProtocol: '请先同意用户协议和隐私政策',
    pleaseInputField: '请填写',

    // 成功提示
    loginSuccess: '登录成功',
    verifyCodeSent: '验证码已发送',

    // 错误提示
    loginFailed: '登录失败，请稍后重试',
    loginFailedNoToken: '登录失败：未获取到token',
    verifyCodeSendFailed: '验证码发送失败',
    verifyCodeSendFailedRetry: '发送验证码失败，请稍后重试',
    verifyCodeError: '验证码错误，请重新输入',
    verifyCodeValidateFailed: '验证码验证失败，请重试',
    verifyCodeRequired: '请先获取验证码',
    verifyCodeInputRequired: '请输入验证码',
    verifyCodeExpired: '验证码已失效',
    verifyCodeExpiredMessage: '手机验证码已过期，请返回重新获取验证码后再进行绑定。',
    backToReVerify: '返回重新验证',
    studentIdNotFound: '学校下没有对应的学号，请核对或使用手机号登录',
    invalidPassword: '密码不正确',
    passwordVerifyFailed: '密码错误，无法换绑手机号登录',
    notModifiedDefaultPassword: '您尚未修改默认密码，为了您的账号安全请先修改密码',
    notBoundPhone: '您还未绑定手机号，请先绑定手机号',
    verifyStudentIdName: '请核对学号对应的姓名，或使用学号密码进行登录。如有疑问，请联系客服',
    studentIdAlreadyBound: '当前学号已与其他微信号绑定，您需要验证密码进行换绑，或使用原手机号验证码登录',
    studentIdBoundToPhone: '当前学号已于手机号{phone}绑定，您需要验证密码进行换绑，或使用原手机号验证码登录',
    rebindPasswordRequired: '当前学号已与其它微信号绑定，您需要验证密码进行换绑',
    getSchoolListFailed: '获取学校列表失败',
    getSchoolListFailedRetry: '获取学校列表失败，请稍后重试',
    getUserInfoFailed: '获取用户信息失败',
    getUserInfoFailedRetry: '获取用户信息失败，请重新登录',
    nameNotMatch: '姓名不匹配，请检查输入的姓名是否正确',
    accountAlreadyBound: '当前学号已与手机号 {phone} 绑定，请使用学号密码进行登录',
    accountAlreadyBoundOther: '当前学号已与其他手机号绑定，请使用学号密码进行登录',
    textLengthExceeded: '输入内容已超过3000字限制',
    wechatBindRequired: '未找到待绑定的微信信息，请重新扫码',
    bindInfoIncomplete: '请填写完整的绑定信息',
    bindSuccess: '绑定成功',
    bindFailedNoToken: '绑定失败：未获取到有效的登录凭证',
    bindFailedNameNotMatch: '请核对学号对应的姓名，或使用学号密码进行登录。如有疑问，请联系客服',
    bindFailedAlreadyBound: '当前学号已与手机号 {phone} 绑定，请使用学号密码进行登录',
    bindFailed: '绑定失败',
    bindFailedUnknown: '绑定失败：未知的返回结果',
    bindFailedRetry: '绑定失败，请稍后重试',
    phoneNotExistNeedBind: '该手机号未注册，请绑定学号',
    phoneBindRequired: '请先完成手机号验证',
    rebindTip: '当前学号已于手机号{phone}绑定，您需要验证密码进行换绑',
    rebindRequired: '请先完成绑定流程',
    rebindSuccess: '换绑成功',
    rebindFailedNoToken: '换绑失败：未获取到有效的登录凭证',
    rebindFailedRetry: '换绑失败，请稍后重试',
    rebindStudentNotExist: '错误，待换绑学生不存在',
    passwordIncorrect: '密码不正确',
    getQrCodeFailed: '获取二维码失败',
    getQrCodeFailedRetry: '获取二维码失败，请稍后重试',
    qrCodeExpired: '二维码已过期，请刷新重新获取',
    tenantDisabled: '租户已禁用',
    wechatLoginSuccess: '微信扫码登录成功',
    accountDisabled: '您的账号已被停用，请联系管理员处理',
    wechatInfoFailed: '获取微信信息失败，请重新扫码',

    // 语言
    language: '语言',
    switchLanguage: '切换语言',

    // 其他登录方式
    otherLoginMethods: '其他登录方式',
    notUseAccountLogin: '若不想使用学号登录，可选择其他登录方式',
    notUsePhoneLogin: '若不想使用手机号登录，可选择其他登录方式',
    notUseWechatLogin: '若不想使用微信扫描登录，可选择其他登录方式',

    // 联系客服
    contactUs: '联系客服',
    customerServiceQrCode: '客服二维码',
    longPressQrcode: '扫描识别二维码，添加客服企业微信',
    addServiceWechat: '添加客服企业微信',

    // 微信登录
    scanQrcodeToLogin: '使用微信扫描下方二维码',
    useWechatScan: '使用微信扫描下方二维码',

    // 提示标题
    tips: '提示'
  },

  // 课程页面
  course: {
    myCourses: '我的课程',
    currentSemester: '当前学期',
    courseName: '课程名称',
    teacher: '老师',
    teachingClass: '教学班',
    assistant24h: '24h伴学助教',
    semester: '学期',
    fallSemester: '秋季学期',
    springSemester: '春季学期',
    class: '班级',
    classCode: '班级码',
    enterClassCode: '请输入班级码',
    inviteJoinClass: '邀请您加入',
    joinClass: '加入班级',
    courseInfo: '课程信息',
    courseDetails: '课程详情',
    chapters: '章节',
    assignments: '作业',
    exams: '考试',
    resources: '资源',
    courses: '门课程',
    viewNow: '立即查看',
    historyCourses: '历史课程',
    noCourses: '暂无课程数据'
  },

  // 首页
  home: {
    // 横幅文案
    bannerTitle: '做你口袋里的学霸朋友',
    bannerSubtitle: '全天候待机·全学科覆盖·全学段助攻',

    // 导航区域
    currentSemesterCourses: '当前学期课程',
    coursesCount: '门课',
    viewNow: '立即查看',
    joinClass: '加入班级',
    scanToJoinClass: '扫码加入班级',
    goToScan: '去扫码',
    enterClassCode: '输入班级码',
    historyCourses: '历史课程',

    // 特色智能体
    featuredAssistants: '特色智能体',
    goToAsk: '去使用',
    noAssistantIntro: '暂无简介',
    noAssistants: '特色智能体',

    // 加入班级弹窗
    joinClassTitle: '加入班级',
    classCodePlaceholder: '请输入班级码',
    classCodeError: '请填写班级码',
    classCodeFormatError: '班级代码格式错误',
    classNotFound: '未查询到班级',
    classNotExist: '班级不存在',
    returnBtn: '返回',
    joinNow: '现在加入',
    joinClassSuccess: '成功加入班级',
    joinClassFailed: '加入班级失败',
    joinClassFailedRetry: '加入班级失败，请稍后重试',

    // 待加入班级
    waitJoinClassTitle: '待加入班级',
    acceptedJoinClass: '已加入班级',
    rejectedInvitation: '已拒绝邀请',
    acceptInvitation: '接受邀请',
    rejectInvitation: '拒绝邀请',
    unknownClass: '未知班级',
    unknownCourse: '未知课程',
    unknownTeacher: '未知教师',
    teacherLabel: '教师：',
    termLabel: '学期：',
    classCodeLabel: '班级编号：',

    // 提示弹窗
    passwordTipTitle: '您未修改默认密码',
    passwordTipContent: '您尚未修改默认密码，为了您的账号安全请先修改密码',
    phoneBindTipTitle: '您未绑定手机号',
    phoneBindTipContent: '您还未绑定手机号，请先绑定手机号',
    wechatBindTipTitle: '微信绑定提示',
    wechatBindTipContent: '您尚未绑定微信，请先绑定微信',
    later: '稍后再说',
    goToModify: '去修改',
    goToBind: '去绑定',

    // 错误提示
    unlistedError: '您不在班级名单中，无法加入班级;如为班级学生,请主动联系教师加入班级名单',
    limitedError: '该班级学生人数已达上限，无法加入'
  },

  // 用户中心
  user: {
    personalCenter: '个人中心',
    changeAvatar: '修改头像',
    personalInfo: '个人信息',
    accountInfo: '账号信息',
    school: '学校',
    college: '学院',
    major: '专业',
    grade: '年级',
    changePassword: '修改密码',
    changePasswordTip: '为了您的账号安全，请修改默认密码',
    modify: '修改',
    bindPhone: '绑定手机号码',
    phoneStatus: '未绑定/已绑定',
    changeBind: '换绑',
    bind: '绑定',
    notBound: '未绑定',
    language: '语言',
    chinese: '中文',
    logout: '退出登录',
    changePasswordTitle: '修改密码',
    passwordRule: '密码需为8-16位的大小写字母和数字组合',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    pleaseInput: '请输入',
    pleaseInputPhone: '请输入您的手机号',
    pleaseInputCode: '请输入验证码',
    bindPhoneTitle: '绑定手机号码',
    changePhoneTitle: '换绑手机号',
    getVerifyCode: '获取验证码',
    verifyCode: '验证码',
    phoneNumber: '手机号',
    customerServiceQrCode: '客服二维码',
    qrCodeTip: '扫描识别二维码，添加客服企业微信',
    logoutConfirm: '确定要退出登录吗？',
    confirm: '确认',
    cancel: '取消',
    complete: '完成',
    // 密码修改相关提示
    pleaseEnterOldPassword: '请输入旧密码',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseConfirmPassword: '请确认新密码',
    passwordMustBeValid: '密码必须为8-16位的大小写字母和数字组合',
    passwordMismatch: '两次输入的密码不一致',
    newPasswordCannotBeSame: '新密码不能与旧密码相同',
    passwordChangeSuccess: '密码修改成功',
    passwordChangeFailed: '密码修改失败',
    passwordChangeFailedRetry: '密码修改失败，请稍后重试',
    // 手机号相关提示
    pleaseEnterPhoneNumber: '请输入手机号码',
    phoneFormatError: '请输入正确的手机号码格式',
    phoneBindSuccess: '手机号绑定成功',
    phoneChangeSuccess: '手机号换绑成功',
    pleaseEnterVerificationCode: '请输入验证码',
    verificationCodeSent: '验证码已发送，请注意查收',
    verificationCodeExpired: '验证码已失效，请重新获取',
    verificationCodeError: '验证码错误，请重新输入',
    logoutFailed: '退出登录失败，请稍后重试',
    pleaseEnterPhoneFirst: '请先输入手机号码',
    phoneAlreadyBound: '该手机号已被绑定，请更换其他手机号',
    pleaseLoginFirst: '请先登录',
    pleaseSelectImageFile: '请选择图片文件',
    imageSizeTooLarge: '图片大小不能超过5MB',
    avatarUploadSuccess: '头像上传成功',
    previewFailed: '预览失败'
  },

  // 聊天/AI助教模块
  chat: {
    aiAssistant: 'AI助教',
    aiAgent: '智能体',
    markAsRead: '标记为已读',
    className: '班级名称',
    ok: '好的',
    copy: '复制',
    knowledgeRelation: '知识点关联',
    courseResources: '资源库内学习资源',
    webResources: '全网学习资源',
    guessYouWant: '猜你想问',
    youCanAsk: '你可以这样问',
    assistant24h: '24h伴学助教',
    chineseLang: '汉语（中文）',
    knowledgePoint: '课程大纲',
    courseWork: '课程作业',
    pleaseInput: '请输入询问 AI 助教/智能体的问题',
    send: '发送',
    view: '去查看',
    switchAssistantMode: '切换助教',
    basicAssistant: '基础助教',
    specialAssistant: '特色智能体',
    currentAssistant: '当前',
    yesterday: '昨天',
    today: '今天',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',

    // 助教设置弹窗
    selectTutorMode: '选择{0}模式',
    selectTutorModePlaceholder: '请选择{0}模式',
    selectChatStyle: '选择对话风格',
    selectChatStylePlaceholder: '请选择对话风格',
    celebrityName: '名人姓名',
    celebrityNamePlaceholder: '请输入语言风格明显的名人',
    celebrityStyle: '名人',
    pleaseInputCelebrityName: '请输入名人姓名',
    saveSettings: '保存设置',
    settingSaved: '设置成功',

    // 助教模式
    normalMode: '普通模式',
    guideMode: '引路人模式',
    mentorMode: '导师模式',
    partnerMode: '伙伴模式',
    expertMode: '专家模式',
    coachMode: '教练挑战模式',
    exampleMode: '举个栗子模式',

    // 语言风格
    normalStyle: '普通',
    professionalStyle: '专业',
    humorousStyle: '幽默',
    rigorousStyle: '严谨',
    friendlyStyle: '亲切',
    sarcasticStyle: '毒舌',
    praiseStyle: '夸夸',
    supportiveStyle: '捧哏',

    // 通知类型标签
    noticeTag: {
      task: '任务',
      course: '课程',
      errorExercise: '错题',
      notice: '通知'
    },

    // 任务通知
    newTaskNotification: '叮!你有新的学习任务，需要在{date} {time}之前提交，过时不候哦! →',
    taskContentUpdated: '叮!你有任务内容发生变更 →',
    taskDeadlineUpdated: '叮!你有任务截止时间修改为{date} {time} →',

    // 底部提示
    aiDisclaimer: '本助教神经元已链接（{img}），AI生成内容需甄别，疑问请联系客服',
    aiDisclaimer2: '本助教神经元已链接（{img}）',
    noCourseEnrolled: '你还没有加入任何课程，加入课程后才可以使用 AI 助教哦',

    // 空状态提示
    noCourseTitle: '你还没有加入任何课程',
    noCourseDesc: '加入课程后才可以使用AI助教哦',

    //语音输入
    voiceInput: '语音输入',
    stopVoiceInput: '停止语音输入',
    sending: '发送中',
    aiThinking: '我的小脑瓜正在知识海洋里蛙泳蝶泳疯狂扑腾ing，马上给宝子捞出最棒的答案！',
    // 多模态
    camera: '拍照',
    filesAndImages: '文件和图片',
    images: '图片',
    files: '文件',
    fileStatusUploading: '上传中',
    fileStatusFailed: '上传失败',
    fileStatusProcessing: '解析中',
    fileStatusSuccess: '解析成功',
    fileStatusParseFailed: '解析失败',
    sendWaitUploadingTip: '请等待所有文件/图片上传并解析完成后，再发送',
    sendFailedAttachmentTip: '存在解析失败的文件/图片，请重试解析或删除后，再发送',
    sendNoContentTip: '请先输入内容，再发送',
    sendConnectingTip: 'AI助教连接中，请稍后再试',
    selectAssistantTip: '请先选择一个助教',
    sendAnsweringTip: '正在回答中，请等待回答完成后再发送',
    sendRecordingTip: '正在录音中，请结束录音后再发送',
    sendUnsupportedFormatTip: '不支持该格式，请选择指定类型文件',
    maxImagesTip: '最多可选择{count}张图片',
    maxFilesTip: '最多可选择{count}个文件',
    maxTotalTip: '最多可选择{count}个图片或文件',
    imageSizeLimitTip: '图片大小不能超过{size}MB',
    fileSizeLimitTip: '文件大小不能超过{size}MB',
    attachmentParseFailedRetry: '{name} 解析失败，请重试',
    attachmentUploadFailedRetry: '{name} 上传失败，请重试',
    answeringVoiceTip: '正在回答中，请等待回答完成后再操作',
    languageSwitchSuccess: '语言切换成功',
    voiceInputNoText: '未识别到文字',
    voiceInputRetry: '语音识别失败，请重试',
    voiceUnsupportedLanguage: '该语言暂不支持语音输入',
    voiceWsFailed: 'WebSocket 连接失败',
    microphonePermissionDenied: '麦克风权限被拒绝，无法使用语音输入',
    microphoneNoDevice: '当前设备无麦克风，无法使用语音输入',
    voiceStartFailed: '录音启动失败，请稍后重试',
    voiceBrowserUnsupported: '浏览器不支持录音或 WebSocket',
    retake: '重拍',
    confirm: '确认',
    cancel: '取消',
    takePhoto: '拍摄',
    upload: '上传',
    cameraUnsupported: '当前浏览器不支持拍照，请使用文件和图片上传',
    cameraPermissionDenied: '相机权限被拒绝，无法使用拍照功能',
    cameraNoDevice: '未检测到可用相机设备',
    cameraNoDeviceWithUploadTip: '未检测到可用相机设备，请使用「文件和图片」方式上传资源',
    cameraUnavailable: '拍照功能暂不可用，请稍后重试',
    cameraSwitchUnsupported: '当前设备暂不支持切换摄像头',
    cameraNotReady: '摄像头尚未就绪，请稍后再试',
    cameraCaptureFailed: '拍照失败，请稍后重试',
    cameraCompressFailed: '拍照图片压缩失败，请重试',
    cameraTakePhotoFirst: '请先拍摄照片',
    uploadTipSupport: '支持上传 {types}',
    uploadTipCount: '最多 {total} 个文件：图片≤{images} 张、文件≤{files} 个',
    uploadTipSize: '单图≤{imageSize}MB，单文件≤{fileSize}MB',
    uploadTooltipAllowedTypes: '当前配置允许的类型',
    uploadTooltipSingleFile: '单个文件',
    uploadTooltipSingleImage: '单张图片',
    uploadTooltipContent: '支持 {types}，{sizeLabel}不超过 {size}MB',
    uploadTypePdf: 'PDF',
    uploadTypeWord: 'Word',
    uploadTypeExcel: 'Excel',
    uploadTypePpt: 'PPT',
    uploadTypeImages: '图片',
    dragUploadTitle: '文件拖到此处可上传',
    maxInputTip: '最多支持输入 {count} 个字',
    noticeCradTitle: {
      ANSWER_PUBLISHED: '答案已公布',
      NOTICE: '通知公告',
      TASK_PUBLISHED: '任务已发布',
      TASK_PENDING: '任务待完成',
      TASK_CHANGED: '任务有变更',
      TASK_DEADLINE: '任务即将截止',
      TASK_REJECTED: '任务已退回',
      WRONG_EXERCISE_FINAL: '期末考试·错题练习',
      WRONG_EXERCISE_MIDTERM: '期中考试·错题练习',
      WRONG_EXERCISE_OTHER: '其他考试·错题练习',
      EXAM_NOTICE: '考试通知',
      EXAM_DEADLINE: '考试即将截止',
      EXAM_SCORE_PUBLISHED: '考试成绩已公布',
      CALL_TASK_CALLED: '选中通知',
      RUSH_TASK_STARTED: '抢答已发布',
    }
  },

  // 课程详情模块
  courseInfo: {
    title: '课程详情',
    all: '全部',
    courseIntro: '课程简介',
    knowledgePoint: '课程大纲',
    tasks: '任务',
    review: '辅重练习',
    errorReview: '错题练习',
    teacher: '老师',
    assistant24h: '24h伴学助教',
    curiosityQuestion: '好奇心提问',
    files: '个文件',
    chapter: '章',
    week: '周',
    weekNum: '第{num}周',
    firstWeek: '第一周',
    secondWeek: '第二周',
    thirdWeek: '第三周',
    homework: '作业',
    exam: '考试',
    resource: '资源',
    notSubmitted: '未提交',
    submitted: '已提交',
    rejected: '已退回',
    finished: '已完成',
    notPracticed: '未练习',
    practiced: '已练习',
    scoreUnit: '分',
    points: '{num}分',
    collapse: '收起',
    expand: '展开',
    taskScore: '任务得分',
    currentTaskScore: '本次任务得分',
    comment: '评语',
    aiComment: 'AI评语',
    viewScoreComment: '查看评分评语',
    gotIt: '我知道了',
    askAI: '问 AI 助教',
    sign: '签到',
    view: '查看',
    courseTodo: '本课程待办',
    studyMaterials: '学习资料',

    // 知识点相关
    emptyKnowledgeTip: '这里是知识的"待开垦区"，别走开，开垦工作正在火热进行中',
    totalTopics: '共{num}个知识/技能点',
    skills: '技能点',
    knowledge: '知识点',

    // 任务相关
    taskDetails: '任务详情',
    taskContent: '任务内容',
    submitTask: '提交任务',
    uploadFile: '上传文件',
    saveDraft: '暂存',
    supportedFormats: '支持上传格式',
    formatDescription: '文件类型：doc，docx，md，xls，xlsx，ppt，pptx，pdf单个文件大小不超过20M；jpg，jpeg，png，bmp单个文件大小不超过10M；支持mp4文件，单个文件大小不超过50M。一个任务最多可上传10个文件',
    submissionTime: '提交时间',
    noTasksAvailable: '暂没有任务哦',
    noTasksTypeAvailable: '暂没有{type}任务哦',
    noCourseTodo: '当前暂无课程待办',
    taskDeadline: '任务已于 {time} 截止',
    taskDeadlineSubmit: '{time} 截止提交',
    allowLateSubmission: '{time} 截止后允许继续提交',
    cannotSubmit: '不能提交内容 如有疑问请询问教师',
    expiredNotSubmit: '任务已截止，不能提交内容',
    askTeacher: '如有疑问请咨询老师',
    rejectReason: '退回原因',
    rejectTime: '退回时间',
    rejectImages: '退回图片',
    rejectedResubmitTip: '请根据退回原因,修改后重新提交',
    currentTaskStatus: '当前任务状态',
    paper: '试卷',
    totalScore: '总分',
    score: '分',
    pleaseEnterAnswer: '请输入对应答案',
    pleaseSelectAnswer: '请选择答案',
    pleaseSelectAtLeastOptions: '请至少选择{count}个选项',
    pleaseSelectAtMostOptions: '请最多选择{count}个选项',
    pleaseFillAnswer: '请填写答案',
    pleaseInputAnswer: '请输入答案',
    multipleChoiceRangeTip: '（最少选 {min} 项，最多选 {max} 项）',
    referenceAnswer: '参考答案',
    selfAnswer: '学生答案',
    analysis: '解析',

    // 题型相关
    singleChoice: '、单选题 （共 {count} 题，共 {score} 分）',
    multipleChoice: '、多选题 （共 {count} 题，共 {score} 分）',
    fillBlank: '、填空题 （共 {count} 题，共 {score} 分）',
    judgeQuestion: '、判断题 （共 {count} 题，共 {score} 分）',
    essayQuestion: '、问答题 （共 {count} 题，共 {score} 分）',
    otherQuestion: '、{type} （共 {count} 题，共 {score} 分）',
    otherQuestionDefault: '其他题目',

    // 题型简称（用于校验提示）
    singleChoiceType: '单选题',
    multipleChoiceType: '多选题',
    fillBlankType: '填空题',
    judgeQuestionType: '判断题',
    essayQuestionType: '问答题',
    otherQuestionType: '其他题目',

    // 错题练习相关
    errorPractice: '错题练习',
    errorQuestion: '错题',
    exerciseQuestion: '练习题',
    weakKnowledgeList: '薄弱知识点清单',
    mistakeQuestions: '错题',
    submit: '提交',
    qIdx: '序号',
    questionType: '题型',
    questionNumber: '题号',
    correspondingKnowledgePoint: '对应知识点',
    keyPointTested: '考察点',
    studentCorrectRate: '学生正确率',
    classAverageCorrectRate: '全班正确率',
    noErrorPracticeAvailable: '暂无错题练习哦',
    questionUnfinished: '题目未完成',
    saveDraftBtn: '暂存',
    submitBtn: '提交',
    scoreLabel: '分',
    accuracy: '正确率',
    uploadByImg: '图片上传',
    uploadByText: '文本输入',

    // 作答思路与过程
    answerProcessTitle: '作答思路与过程',
    answerProcessPlaceholder: '请上传你的解题过程或思路说明',
    answerProcessImageLimit: '每道题最多上传3张图片',
    answerProcessImageFormat: '仅支持"jpg", "jpeg", "png", "bmp", "webp"格式',
    answerProcessImageSize: '图片大小不能超过10MB',
    answerProcessRequired: '请填写作答思路或上传图片',
    answerProcessSubmitFailedTitle: '提交失败',
    answerProcessSubmitFailedContent: '有题目未提交解题过程，请补充完整后再提交',

    // 布鲁姆教育目标分类 - 考察点
    bloomRemember: '记忆',
    bloomUnderstand: '理解',
    bloomApply: '应用',
    bloomAnalyze: '分析',
    bloomEvaluate: '评价',
    bloomCreate: '创造',

    // 其他
    needHelp: '有问题？问 AI 助教',
    back: '返回',

    // 文件上传相关
    document: '文档',
    pdf: 'PDF',
    spreadsheet: '表格',
    presentation: 'PPT',
    video: '视频',
    image: '图片',
    zip: '压缩包',
    maxFileCount: '不能超过{count}个文件',
    fileTypeTipTitle: '文件类型提示',
    supportVideoTip: '支持mp4文件，单个文件大小不超过500M。',
    supportDocTip: '{types}类型的文件，单个文件大小不超过20M；',
    fileLimitTip: '支持 {fileTypes} 类型的文件，单个文件不超过{limit}M',
    maxUploadCount: '一个任务最多可上传{count}个文件。',
    notSupportFormat: '不支持格式',
    fileSizeExceeded: '超过大小文件',
    fileSizeTip: '（mp4格式不超过500M，其他不超过50M）',
    fileExceedSize: '以下文件超过了{size}M',
    copyLinkTip: '复制网页端链接前往',
    copyDownloadLinkTip: '请复制下载链接，在手机浏览器地址栏粘贴打开即可下载文件。',

    // 课程阶段
    phase: {
      before: '课前',
      during: '课中',
      after: '课后'
    },
    // 任务类型
    taskType: {
      general: '通用任务',
      quiz: '出题练习',
      bullet: '课堂讨论',
      group: '分组任务',
      vote: '投票',
      survey: '问卷',
      notice: '通知',
      call: '点答',
      rush: '抢答',
      exam: '考试',
      checkin: '签到',
      wrongExercise: '错题练习',
    },

    running: '进行中',
    pending: '未开始',
    expired: '已结束',
    deadlineLabel: '截止时间：',

    // 已读未读
    read: '已读',
    unread: '未读',
    // 阅读时间
    readTime: '阅读时间',
    published: '已发布'
  },

  // 提示消息模块
  message: {
    copySuccess: '复制成功',
    // 通用提示
    success: '操作成功',
    error: '操作失败',
    networkError: '网络错误，请您检查网络！',
    requestTimeout: '请求超时，请稍后重试！',
    networkBusy: '网络开小差了，请稍后再试~',
    serverError: '服务器响应异常',
    dataIncomplete: '响应数据不完整',
    operationFailed: '操作失败',
    operationFailedRetry: '操作失败，请稍后重试',
    getAssistantListFailed: '获取助手列表失败',
    unknownTime: '未知时间',
    logoutSuccess: '退出登录成功',

    // 题目相关
    question: '第',
    questionNo: '题',

    // 错题练习相关提示
    missingRequiredParams: '缺少必要参数',
    missingTaskParams: '缺少任务参数',
    getErrorDetailFailed: '获取错题详情失败',
    exerciseSaved: '练习已暂存',
    saveFailed: '暂存失败',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    pleaseCompleteAtLeastOne: '请至少完成一道练习题',
    confirmSubmit: '确定提交练习吗？提交后将无法修改答案',
    confirmSubmitBtn: '确认提交',
    unansweredQuestions: '以下题目尚未作答，请完成后再提交',
    gotIt: '知道了',
    tip: '提示',
    cancel: '取消',

    // 任务相关提示
    incompleteParams: '参数不完整，无法获取任务详情',
    taskNotFound: '正在跳转到错题详情...',
    getTaskDetailFailed: '该任务已不存在',
    taskInfoNotExist: '任务信息不存在',
    taskNotExist: '任务不存在',
    saveSuccess: '暂存成功',
    notEditable: '当前状态不可编辑',
    pleaseSelectImage: '请选择图片文件',
    imageSizeLimit: '图片大小不能超过5MB',
    imageUploadSuccess: '图片上传成功',
    imageUploadFailed: '图片上传失败，请稍后重试',
    imageDeleted: '图片已删除',
    imageUploadedCannotEnterText: '已上传图片，无法输入文本',
    uploading: '上传中...',
    uploadingImage: '正在上传图片...',
    confirmSubmitTitle: '提交确认',
    confirmSubmitContent: '提交任务后就不可以修改了哦，确定提交了吗！',
    unansweredWarning: '以下题目尚未作答，请完成后再提交：',
    moreQuestions: '等 {count} 道题',
    pleaseInputTaskContent: '请输入任务内容',
    pleaseUploadFile: '请上传文件',
    maxFileCountLimit: '最多只能上传{count}个文件',
    fileSizeLimit: '文件 {fileName} 大小不能超过{size}',
    fileUploadSuccess: '{fileName} 上传成功',
    fileUploadFailedWithName: '{fileName} 上传失败: {error}',
    fileTypeNotAllowed: '文件类型不符合要求，请上传符合要求的文件类型',
    someFilesTypeNotAllowed: '部分文件类型不符合要求，已自动过滤',
    tryAgainLater: '请稍后重试',
    submitting: '提交中...',
    noTaskInfo: '暂无任务信息',

    // 登录相关提示
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    loginFailedRetry: '登录失败，请稍后重试',
    loginExpired: '登录已经过期，请重新登录！',
    pleaseInputPhone: '请输入手机号',
    pleaseInputCorrectPhone: '请输入正确的手机号',
    verifyCodeSent: '验证码已发送',
    sendVerifyCodeFailed: '发送验证码失败',
    sendVerifyCodeFailedRetry: '发送验证码失败，请稍后重试',
    suggestBindPhone: '建议您绑定手机号，以便更好地使用系统',
    pleaseBindStudentId: '请绑定学号信息',

    // 课程相关提示
    noSemesterData: '暂无学期数据',
    loadedCourses: '加载了 {count} 门课程',
    loadCourseFailed: '加载课程失败',
    pleaseInputClassCode: '请输入班级码',
    classNotFound: '未查询到班级',
    foundClass: '查询到班级: {name}',
    joinClassSuccess: '成功加入班级',
    joinClassFailed: '加入班级失败',
    unlistedError: '您不在班级名单中，无法加入班级；如为班级学生，请主动联系教师加入班级名单',
    limitedError: '该班级人数已达上限；如为班级学生，请主动联系教师加入班级名单',

    // WebSocket相关
    noAssistant: '你还没有加入任何课程，加入课程后才可以使用 AI 助教哦',
    wsConnectSuccess: 'WebSocket连接成功',
    wsConnectError: 'WebSocket连接错误',
    wsConnectClosed: 'WebSocket连接已关闭',
    connectFailed: '连接失败',
    pleaseInputQuestion: '请输入问题',

    // 客服相关
    wechatScanCode: '微信扫一扫',
    contactCustomerService: '添加客服咨询',

    // 语言切换
    languageSwitched: '切换语言成功'
  },

  // 导航标题
  nav: {
    taskCenter: '任务中心',
    mistakeExercise: '错题练习',
    taskDetails: '任务详情',
    signInDetails: '签到详情',
    signInBreakdown: '签到明细'
  },
  imageEditor: {
    title: '图片编辑',
    cancel: '取消',
    confirm: '确认',
    confirmUpload: '确认上传',
    continueEdit: '继续编辑',
    discardEditTitle: '放弃编辑',
    discardEditContent: '是否放弃本次编辑？已编辑内容将不保存',
    discardConfirm: '确认放弃',
    saveFailed: '图片编辑保存失败，请重试',
    loadFailed: '图片加载失败，无法编辑',
    imageLoading: '图片加载中...',
    noImage: '暂无图片',
    filePreview: '文件预览',
    imagePreview: '图片预览',
    noFiles: '暂无文件',
    selectAtLeastOne: '请至少选择一个文件',
    maxFiles: '最多只能选择 {limit} 个文件',
    editImage: '编辑图片',
    edit: '编辑',
    delete: '删除',
    defaultText: '点击编辑',
    undo: '撤回',
    undoTip: '撤回一步 (Ctrl+Z)',
    restoreCrop: '还原裁剪',
    restoreCropAndZoom: '还原裁剪与缩放',
    resetZoom: '还原缩放',
    restoreRotate: '还原至旋转前',
    restore: '还原',
    reset: '还原',
    deleteSelectedText: '删除选中文字',
    clearAnnotation: '清除',
    clearAnnotationTip: '清除全部标注',
    rotate: '旋转',
    rotateTip: '旋转 90°',
    zoomIn: '放大',
    zoomOut: '缩小',
    crop: '裁剪',
    text: '文字',
    addText: '添加文字',
    annotation: '标注',
    freeAnnotation: '自由标注',
    confirmCrop: '确认裁剪',
    confirmWithCount: '确定 ({count})',
    textEditDone: '完成',
  },

  task: {
    signIn: {
      reminder: '签到提醒',
      signInStarted: '签到进行中，请尽快完成签到',
      noSignInTask: '暂无签到任务',
      defaultCourseName: '课程',
      defaultTaskName: '签到',
      courseCheckInStarted: '【{courseName}】的【{taskName}】开始签到啦，记得及时完成哦！',
      nthCheckInStarted: '【{courseName}】的【{taskName}】第{round}轮开始签到啦，记得及时完成哦！',
      weekDay: '第 {week} 周 周{day}',
      weekOnly: '第 {week} 周',
      countdown: '倒计时：{time}',
      countdownLabel: '倒计时:',
      checkInProgress: '签到进行中，请尽快完成签到',
      checkInEnded: '签到已结束',
      goToCheckIn: '去签到',
      cancel: '取消',
      checkIn: '签到',
      details: '签到详情',
      scanQrCodeTitle: '扫描签到二维码',
      scanQrCode: '请扫描二维码',
      enterCheckInCode: '请输入签到码',
      incorrectCode: '签到码输入错误',
      invalidQRCode: '无效的签到二维码',
      takePhoto: '拍照',
      retakePhoto: '重新拍照',
      usePhoto: '使用照片',
      photoRequirement: '拍照要求',
      codeRequired: '签到码不能为空',
      nthTime: '第 {count} 次',
      success: '签到成功',
      failed: '签到失败',
      networkError: '网络异常',
      outOfRange: '未处于签到范围无法进行签到',
      outOfRangeLineOne: '未处于签到范围',
      outOfRangeLineTwo: '无法进行签到',
      records: '签到记录',
      weekdays: {
        monday: '周一',
        tuesday: '周二',
        wednesday: '周三',
        thursday: '周四',
        friday: '周五',
        saturday: '周六',
        sunday: '周天'
      },
      weekdaysShort: {
        mon: '周一',
        tue: '周二',
        wed: '周三',
        thu: '周四',
        fri: '周五',
        sat: '周六',
        sun: '周天'
      },
      calendarWeekTitle: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      dateFormat: 'YYYY 年 M 月 D 日',
      monthFormat: 'YYYY 年 M 月',
      status: {
        present: '正常',
        absent: '缺勤',
        abnormal: '异常考勤',
        leave: '请假',
        late: '迟到',
        success: '成功',
        failed: '失败',
        pending: '进行中',
        signing: '签到中'
      },
      breakdown: '签到明细',
      abnormalRecords: '签到异常记录',
      recordDetail: '第 {week} 周 周{day} | 第 {count} 次签到',
      summaryWithIndex: '第 {week} 周 周{day} 第 {count} 次签到',
      noTasksThisMonth: '本月暂无任务',
      startCheckIn: '开始签到',
      abnormalReminderTitle: '签到提醒',
      teacher: '教师',
      abnormalWarning: '你有未签到或签到异常的课程，请及时联系教师进行处理',
      teacherHandled: '教师已处理为<{status}>',
      viewDetails: '查看详情',
      nthSignIn: '第{n}次签到',
      checkInType: '第{count}轮签到（{type}）',
      checkedIn: '已签到',
      uncheckedIn: '未签到',
      roundLabel: '第 {count} 轮',
      noRoundData: '暂无签到轮数据',
      startCheckInAt: '开始签到：{time}',
      prevRecord: '上一条',
      nextRecord: '下一条',
      locating: '定位中...',
      locatingWait: '定位中，请稍候...',
      retryLocate: '重试定位',
      locationAcquired: '已获取当前位置',
      checkInPoint: '签到点',
      distanceToCheckInPoint: '距离「{name}」约 {distance} 米',
      enableLocationPermission: '请开启定位权限后重试',
      enableCameraPermission: '请开启相机权限后重试',
      noCameraCheckInOnPc: '设备无摄像头 无法进行【扫码和拍照签到】 请使用微信小程序进行签到',
      noCameraCheckIn: '未检测到可用摄像头',
      cameraUnavailable: '相机暂不可用，请稍后重试',
      photoFeatureDeveloping: '拍照功能开发中',
      nearby: '附近',
      checkInCompletedAt: '已于 {time} 完成签到',
      clickToCheckIn: '请点击底部按钮签到',
      browserNotSupport: '您的浏览器不支持地理位置功能',
      browserLocationNotSupported: '浏览器不支持定位',
      locationErrorTip: '定位异常无法签到时，可在U课AI微信小程序进行签到',
      permissionDenied: '请允许获取您的位置信息',
      positionUnavailable: '无法获取位置信息',
      timeout: '获取位置超时',
      locationFailed: '获取位置失败',
      getDetailFailed: '获取签到详情失败',
      targetLocation: '目标地点',
      monthDayFormat: 'MM月DD日',
      time: '时间',
      location: '地点',
      fullDateFormat: 'MM月DD日 dddd',
      noAbnormalRecords: '暂无异常记录',
      type: {
        normal: '普通签到',
        ordinary: '普通签到',
        qrCode: '二维码签到',
        code: '签到码签到',
        photo: '拍照签到',
        location: '定位签到'
      },
      notFoundSignInTask: '签到任务不存在或已删除'
    },
    callAndRush: {
      notStart: '未开始',
      selectionNotification: '抽中提醒',
      callReason: '点答事由',
      rushReason: '抢答事由',
      youAreSelected: '你在【{courseName}】课程中被抽中啦！',
      youAreSelectedShort: '抽中啦！',
      prepareToAnswer: '请准备好回答问题 老师正在等待你的反馈～',
      prepareToAnswerShort: '注意配合老师回答哦～',
      notSelected: '本次未被抽中！',
      notSelectedHint: '本次未被抽中，下次积极参与哦～',
      rushAlert: '抢答提醒',
      countdownStarted: '你的【{courseName}】课程第{roundNum}轮抢答开始了！',
      goToRush: '去抢答',
      notParticipated: '未参与',
      callSelected: '点答抽中',
      callNotSelected: '未抽中',
      rushFailed: '抢答失败',
      rushSuccessful: '抢答成功',
      rushFailedMessage: '抢答失败！',
      tryAgain: '下回再接再厉！',
      rushSuccessMessage: '恭喜抢答成功！',
      notParticipatedMessage: '你未参与本次抢答',
      joinNextTime: '下次积极参与哦～',
      go: '抢',
      rush: '抢',
      teacherRating: '教师评分',
      comment: '评语',
      noRounds: '暂无开始轮次',
      round: '第{num}轮',
      rushFailedRetry: '抢答失败，请重试',
      bannedTitle: '你已经抢过啦！',
      bannedHint: '本次抢答任务每位同学仅能参与一次哦～',
      cancel: '取消'
    },
    testTask: {
      finalExam: '期末考试',
      midtermExam: '期中考试',
      otherExam: '其他考试',
      duration: '考试时长：{0} 分钟',
      forceSubmitDeadlineNotice: '本次考试将于 {0} 截止，到达时间将强制交卷',
      startExam: '开始考试',
      exitAutoSubmitNote: '注意：考试中退出或关闭即强制自动交卷',
      countdown: '考试倒计时',
      submitPaper: '交卷',
      examEnded: '考试已结束',
      inProgressWarning: '考试进行中，请勿退出或关闭页面，若强制退出或关闭，系统将默认自动交卷',
      examTimeUp: '考试时间已到，系统已自动交卷',
      confirmSubmitTitle: '确认交卷',
      confirmSubmitContent: '确定要提交试卷吗？提交后不可修改。',
      exitWarningTitle: '考试进行中',
      tabSwitchWarning: '请注意考场纪律',
      continueAnswering: '继续答题',
      unfinishedTitle: '提示',
      unfinishedContent: '你还有 {0} 道题目未完成，确定提交吗？',
      totalScoreLabel: '总分：{0}分',
      examInfo: '考试信息',
      examContent: '考试内容',
      examRequirement: '考试要求',
      examName: '考试名称',
      offlineNotice: '网络已断开，答案已本地保存，重连后自动同步',
      reconnectedNotice: '已重连，答案已同步',
      localSubmittedNotice: '网络未恢复，已本地交卷，重连后自动同步至服务端',
      resumeDraftTitle: '提示',
      resumeDraftContent: '检测到上次未完成的作答记录，是否继续？',
      resumeDraftContinue: '继续',
      resumeDraftDiscard: '放弃',
      submittedTip: '试卷已提交',
      exitPromptTitle: '提示',
      exitPromptMain: '考试进行中，请勿退出或关闭页面',
      exitPromptSub: '若强制退出或关闭，系统将默认自动交卷',
      exitBack: '返回',
      exitSubmit: '交卷',
      examResult: '考试结果'
    }
  },

  // 智能体广场 & 学生端优化
  agentSquare: {
    taskUnsubmitted: '任务未提交',
    attendanceIssue: '签到异常',
    leaveClass: '退出',
    totalSessions: '总课堂数',
    unsubmittedTasks: '未提交任务',
    attendanceRate: '出勤率',
    learningCenter: '学习中心',
    sessionDetail: '课堂详情',
    xSessions: '课堂X个',
    taskCenter: '任务中心',
    xUnsubmitted: '未提交X个',
    attendanceCenter: '签到中心',
    xAttendanceIssues: '签到异常X次',
    aiTutor: 'AI助教',
    aiAgent: '智能体',
    keyPoints: '知识/技能',
    errorReview: '错题练习',
    xTasks: 'X个任务',
    xFiles: 'X个文件',
    inClassTasks: '课堂任务',
    classMaterials: '课堂资料',
    sharedMaterials: '教师已开放的课件和资料',
    all: '全部',
    unsubmitted: '未提交',
    returned: '已退回',
    completed: '已完成',
    noAgentsAvailable: '暂无智能体可使用',
    noAgents: '暂无智能体',
    sourceAgentDeleted: '智能体已被原创作者下架或删除',
    remove: '移除',
    removeConfirmTitle: '确认移除',
    removeConfirmContent: '确定要移除「{name}」吗？移除后该智能体将不再显示在列表中',
    removeConfirmOk: '确认移除',
    removeSuccess: '移除成功',
    removeFailed: '移除失败',
    markAllReadSuccess: '已全部标记为已读',
    taskPublished: '任务已发布',
    taskUpdated: '任务有变更',
    taskPending: '任务待完成',
    taskReturned: '任务已退回',
    taskDueSoon: '任务即将截止',
    finalExamErrorReview: '期末考试·错题练习',
    midtermExamErrorReview: '期中考试·错题练习',
    otherExamErrorReview: '其他考试·错题练习',
    announcements: '通知公告',
    view: '查看',
    groupTask: '分组任务',
    discussion: '课堂讨论',
    quizPractice: '出题练习',
    generalTask: '通用任务',
    poll: '投票',
    survey: '问卷',
    checkIn: '签到',
    coldCall: '点答',
    buzzIn: '抢答',
    exam: '考试',
    notice: '通知'
  },
  taskCard: {
    all: '全部',
    unfinished: '未完成',
    finished: '已完成',
    rejected: '已退回',
    remainDays: '剩{n}天',
    remainHours: '剩{n}小时',
    remainUnderHour: '剩不足1小时',
    overdueDays: '逾期{n}天',
    overdueHours: '逾期{n}小时',
    overdueHour: '逾期1小时',
    cannotSubmit: '不可提交',
    inProgress: '进行中',
    canLateSubmit: '仍可补交',
    deadline: '{time}截止',
    publishedAt: '{time}发布',
    rounds: '共{n}轮',
    drawnRounds: '被抽中{n}轮',
    notDrawn: '未被抽中',
    grabbedRounds: '已抢到{n}轮',
    notGrabbed: '未抢到',
    notJoined: '未参与',
    absent: '缺勤',
    fullAttendance: '全勤',
    signedRounds: '已签到{n}轮',
    scoreUnit: '分',
    returnedResubmit: '教师退回，请重新提交',
    noTasksYet: '老师还没有发布任务',
    newTasksAppear: '有新任务时会在这里出现',
    noStatusTasks: '本学期暂无「{name}」的任务',
    switchStatusHint: '换个状态看看，或点左上角周次跳转',
    noClassTasks: '本堂课暂无任务',
    noClassStatusTasks: '本堂课暂无「{name}」的任务',
    switchStatus: '换个状态看看',
    noMaterials: '本堂课暂无资料',
    noClassrooms: '暂无课堂',
    classroomsAppear: '课堂内容发布后会在这里出现',
    weekGuide: '按周次从新到旧排列，向下滚动查看更早周次',
    jumpWeek: '跳转到周次',
    redDotLegend: '红点表示该周有还能提交的未完成任务',
    weekNum: '第 {n} 周',
    thisWeek: '本周',
    totalPrefix: '共',
    weekTotal: '共 {n} {unit}',
    loadFailed: '加载失败，点击重试',
    taskUnit: '个任务',
    classUnit: '堂课',
    taskWord: '任务',
    tasksCompleted: '任务已完成',
    taskProgress: '任务情况 完成',
    files: '文件',
    fileUnit: '个',
    noTask: '暂无任务',
    noResource: '暂无资料',
    emptyTodo: '暂无待办，继续保持',
    emptyTodoHint: '有新任务时会在这里提醒你'
  }
}
